import React from "react";

/**
 * Full "can't set up your data" state for the sign-up flow's initial load --
 * replaces the bare CustomAlert banner (which left the rest of the page blank
 * with no context) with a proper error page: icon, heading, the specific
 * message, and something the person can actually do next.
 */
export const SystemErrorState = ({ message }) => {
  return (
    <div className="row">
      <div className="col-sm-12">
        <div
          className="text-center"
          style={{ padding: "60px 20px", maxWidth: 520, margin: "0 auto" }}
        >
          <div style={{ fontSize: 56, color: "#d9534f", lineHeight: 1 }}>&#9888;</div>
          <h3 style={{ marginTop: 20, marginBottom: 10 }}>We couldn't load your information</h3>
          <p style={{ fontSize: 16, color: "#555" }}>{message}</p>
          <p style={{ fontSize: 14, color: "#888", marginTop: 20 }}>
            If you keep seeing this, reach out to{" "}
            <a href="mailto:sales@greenlinknetworks.com">sales@greenlinknetworks.com</a> and
            we'll help you get set up.
          </p>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Notification/SystemErrorState.js